import { render } from "./PhotoView.vue?vue&type=template&id=4e395b40"
import script from "./PhotoView.vue?vue&type=script&lang=js"
export * from "./PhotoView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__